export default __webpack_public_path__ + "static/media/lightHamburgerIcon.58d7a54c.svg";